import styled from 'styled-components';

interface UnitSwitchProps {
  unit: string;
  setUnit: (unit: string) => void;
  icon?: boolean;
}

const UnitSwitch = ({ unit, setUnit, icon }: UnitSwitchProps) => {
  return (
    <UnitSwitchBtn
      onClick={() => {
        unit === '평' ? setUnit('m²') : setUnit('평');
      }}
    >
      {icon && <img src="/assets/images/icon/refresh.svg" alt="switch" />}
      {unit === '평' ? 'm²' : '평'}
    </UnitSwitchBtn>
  );
};

export default UnitSwitch;

const UnitSwitchBtn = styled.div`
  height: 24px;
  padding: 4px 6px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 4px;
  border: 1px solid rgba(112, 115, 124, 0.22);
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  color: rgba(23, 30, 38, 1);
  cursor: pointer;
  background-color: #fff;
`;
